import { PointsBlock } from "../../../PointsBlock";
import { useCartOverviewTierContext } from "../../context";
import { StatusMessage } from "../StatusMessage";

export const CartOverviewTierContent = () => {
  const { points, pointsLabel, pointsText, knowMoreUrl, knowMoreLabel, statusMessage, isLoading } =
    useCartOverviewTierContext();

  return (
    <>
      <PointsBlock
        points={points}
        pointsLabel={pointsLabel}
        text={pointsText}
        knowMoreUrl={knowMoreUrl}
        urlText={knowMoreLabel}
      />
      <StatusMessage message={statusMessage} isLoading={isLoading} />
    </>
  );
};
